import { ConvertedRealEstate } from './real-estate-api-types'

export interface ObjectChooserInformation {
  objects?: ConvertedRealEstate[]
  displayObjectChooser: DisplayObjectChooserType
  insertionFlowDataLoaded: boolean
  objectChooserBackButton: boolean
  objectSelected: boolean
  objectChooserShown: boolean
}

export enum DisplayObjectChooserType {
  YES = 'YES',
  NO = 'NO',
  LOADING = 'LOADING',
  UNKNOWN = 'UNKNOWN',
}
